import { CollaboratorService } from './../core/service/assignment-employee/collaborator.service';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { AuthService } from '../core/service/auth/auth.service';
import { UserStateService } from '../core/service/user/user-state.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {

    items!: MenuItem[];

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;
    employeeCode: string = '';
    assignmentId: string = '';
    user: string;
    ubicacionParqueo: string;

    constructor(public layoutService: LayoutService, private auth: AuthService,
        private confirmationService: ConfirmationService, private messageService: MessageService,
        private collaboratorService: CollaboratorService,
        private userStateService: UserStateService

    ) { }

    ngOnInit() {
        const payload = this.auth.getTokenPayload();

        if (payload && payload.employeeCode && payload.assignmentId) {
            //console.log('Payload:', payload);
            this.user = payload.user;
            this.employeeCode = payload.employeeCode;
            this.userStateService.employeeCode = this.employeeCode;
            this.userStateService.assignmentId = payload.assignmentId;
           // console.log('Estado guardado:', this.employeeCode, this.assignmentId);
        } else {
            console.error('Token inválido o sin employeeCode.');
            this.auth.logout();
            return;
        }

        //console.log('Código empleado para consulta:', this.employeeCode);

        if (this.employeeCode) {
            this.collaboratorService.getEmployeeData(this.employeeCode).subscribe({
                next: (response) => {
                    if (response.data?.location?.name) {
                        this.ubicacionParqueo = response.data.location.name;
                    } else {
                        console.warn('No se encontró la ubicación del colaborador en la respuesta.');
                    }
                },
                error: (error) => {
                    console.error('Error al obtener la ubicación del usuario:', error);
                }
            });
        } else {
            console.error('employeeCode está vacío, no se puede hacer la petición');
        }
    }




    confirmLogout(event: Event) {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: '¿Estás seguro de cerrar sesión?',
            icon: 'pi pi-exclamation-circle',
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            accept: () => {
                this.onLogout();
            }
        });
    }


    onLogout() {
        this.auth.logout()
    }

    reloadPage(): void {
        window.location.reload();
    }

}
